import React, {ReactElement} from 'react'
import {Backdrop, CircularProgress} from "@mui/material";
import {useSelector} from "react-redux";
import {LoadingState} from "../redux/slices/loading.slice";

type Props = {
    children: ReactElement
}

export const LoadingProvider: React.FC<Props> = ({ children }) => {
    const loading = useSelector((state: { loading: LoadingState }) => state.loading);
    return <>
        <Backdrop sx={{
            zIndex: 99999999,
            color: '#fff',
        }}  open={loading.isLoading}>
            <CircularProgress color="inherit" />
        </Backdrop>
        { children }
    </>
}